<template>
  <div>
    <detail :prop="i18n.lbl_receiver()" :value="tx.counterparty" :copiable="true"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(tx.amount)} ${tx.asset}`"/>
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <detail :prop="i18n.lbl_invoice_number()" :value="tx.invoiceNumber"/>
    <detail :prop="i18n.lbl_see_details_in_contract()"/>
    <detail></detail>
  </div>
</template>

<script>
  import DetailsMixin from './details.mixin'

  export default {
    name: 'invoice-details',
    mixins: [DetailsMixin]
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.Invoice.vue